import pickBy from 'lodash/pickBy';

export default (object: Record<string, any>) => pickBy(object, (x) => x);
